export default __webpack_public_path__ + "static/media/accede_pa.dbcebe2d.jpg";